import { render, staticRenderFns } from "./ManageReleases.vue?vue&type=template&id=6349ad05&scoped=true"
import script from "./ManageReleases.vue?vue&type=script&lang=js"
export * from "./ManageReleases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6349ad05",
  null
  
)

export default component.exports